import header from "./header.json";
import navbar from "./navbar.json";

export const navEN = {
	header,
	navbar,
};
